<template>
  <div class="user-list">
    <el-tabs v-model="searchParam.status" type="card" @tab-click="getList">
      <el-tab-pane label="上架" name="1"></el-tab-pane>
      <el-tab-pane label="下架" name="2"></el-tab-pane>
    </el-tabs>
    <div class="search-bar flex">
      <div class="left">
        <div class="search-bar">
          <el-input
            v-model="searchParam.keyword_search"
            suffix-icon="el-icon-search"
            placeholder="输入要搜索的内容"
            clearable
            @clear="getList"
          ></el-input>
          <el-button type="primary" @click="searchList">搜索</el-button>
        </div>
      </div>
      <div class="right">
        <el-button type="primary" size="small" @click="addSwiper"> 新建 </el-button>
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="id" label="序号" fixed="left"> </el-table-column>
        <el-table-column prop="title" label="轮播图名称"> </el-table-column>
        <el-table-column prop="img" label="图片">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.cover"
              fit="contain"
              :preview-src-list="[scope.row.cover]"
            >
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建日期"> </el-table-column>
        <el-table-column label="操作" fixed="right" width="250">
          <template slot-scope="scope">
            <el-button class="mid-blue" @click="editItem(scope.row)">编辑</el-button>
            <el-button v-if="scope.row.status == 1" class="mid-red" @click="xiajia(scope.row)">下架</el-button>
            <el-button v-else class="mid-blue" @click="xiajia(scope.row)">上架</el-button>
            <el-button class="mid-red" @click="deleteItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page">
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery.page_index"
          :limit.sync="listQuery.page_size"
          @pagination="getList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { getBanner, bannerStatus, delBanner } from "@/api/operation.js";
export default {
  components: { Pagination },
  data() {
    return {
      total: 10,
      listQuery: {
        page_index: 1,
        page_size: 10,
      },
      searchParam: {
        status: "1",
      },
      tableData: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    editItem(row) {
      if (row) {
        row = { ...row, uuid: row.id };
      }
      this.$router.push({
        path: "/swiper-add",
        query: row,
      });
    },

    deleteItem(row) {
      this.$confirm("确定要删除该轮播图吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // TODO : 轮播图删除接口对接
          delBanner(row.id).then((res) => {
            if (res) {
              this.$message.success("成功");
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    searchList() {
      this.listQuery.page_index = 1;
      this.getList();
    },
    async getList(type) {
      const param = { ...this.searchParam, ...this.listQuery };

      // param[this.skey] = this.searchParam.keyword_search
      this.loading = true;
      const res = await getBanner(param);
      this.loading = false;
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      } else {
        this.tableData = [];
        this.total = 0;
      }
      console.log(res);
    },
    xiajia(row) {
      this.$confirm("确定要" + (this.status == 1 ? "上架" : "下架") + "该轮播图吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          bannerStatus(row.id).then((res) => {
            if (res) {
              this.$message.success("成功");
              this.getList();
            }
          });
        })
        .catch(() => {});
    },

    addSwiper() {
      this.$router.push({
        path: "/swiper-add",
      });
    },
  },
};
</script>

<style scoped="scoped">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
</style>
